package ui

import api.data.DataProperty
import api.data.DataVisitSchedule
import dataProperties
import dataVisitSchedules
import js.objects.jso
import react.*
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.span
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.h3
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.select
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.label
import routes.EnumRoutes
import ui.components.CloseIcon
import ui.components.DashboardIcon
import ui.components.DataSidebarMenu
import ui.components.InquiriesIcon
import ui.components.ListingsIcon
import ui.components.MenuIcon
import ui.components.NavBar
import ui.components.OwnerSubmissionsIcon
import ui.components.ScheduleIcon
import utils.localDateFromString
import web.cssom.ClassName
import web.cssom.FontFamily
import web.cssom.string
import kotlin.math.truncate

// External interfaces for props
external interface SidebarItemProps : Props {
    var icon: ReactNode?
    var label: String
    var isActive: Boolean?
    var to: String?
}

external interface VisitRowProps : Props {
    var name: String
    var property: String
    var type: String
    var email: String
    var phone: String
    var status: String
    var id: String
    var avatar: String
    var onClick: (() -> Unit)?
}

// VisitRow Component
val VisitRow = FC<VisitRowProps> { props ->
    val dataProperty = getPropertyById(props.id)

    button {
        onClick = { props.onClick?.invoke() }
        className = ClassName("w-full text-left")

        div {
            className = ClassName("flex justify-center items-start gap-4 border-b border-gray-200 py-4 hover:bg-gray-50")

            div {
                className = ClassName("flex-1 justify-center flex items-center")
//                className = ClassName("flex-1 flex items-center gap-3")
//                img {
//                    src = props.avatar
//                    alt = props.name
//                    className = ClassName("w-8 h-8 rounded-full")
//                }
                div {
                    className = ClassName("text-sm font-normal text-black")
                    style = jso {
                        fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                    }
                    +props.name
                }
            }

            div {
                className = ClassName("flex-1 justify-center flex items-center")
                div {
                    className = ClassName("text-sm font-normal text-black")
                    style = jso {
                        fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                    }
                    +props.property
                }
            }

            div {
                className = ClassName("flex-1 justify-center flex items-center")
                div {
                    className = ClassName("text-sm font-normal text-black")
                    style = jso {
                        fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                    }
                    +props.phone
                }
            }

            div {
                className = ClassName("flex-1 justify-center flex items-center")
                div {
                    className = ClassName("text-sm font-normal text-black")
                    style = jso {
                        fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                    }
                    +props.email
                }
            }

            div {
                className = ClassName("flex-1 justify-center flex items-center")
                div {
                    className = ClassName("text-sm font-normal text-black")
                    style = jso {
                        fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                    }
                    +dataProperty?.type
                }
            }
            div {
                className = ClassName("flex-1 justify-center flex items-center")
                div {
                    className = ClassName("text-sm font-normal text-black")
                    style = jso {
                        fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                    }
                    +props.status
                }
            }
        }
    }
}

// Visit data class
data class Visit(
    val name: String,
    val property: String,
    val type: String,
    val email: String,
    val status: String,
    val avatar: String
)

// Form data class
data class FormData(
    val visitorName: String = "",
    val property: String = "",
    val email: String = "",
    val phone: String = "",
    val dateTime: String = ""
)

external interface VisitScheduleProps : Props{
    var visitSchedule: ArrayList<DataVisitSchedule>
}

fun getPropertyById(id: String): DataProperty?{
   return dataProperties.firstOrNull {property->
        property.id == id
    }
}

val PageVisitSchedule = FC<VisitScheduleProps> {
    var activeTab by useState("All")
    var formData by useState(FormData())
    var visits by useState(it.visitSchedule)
    var selectedVisit by useState<DataVisitSchedule?>(null)
    var selectedStatus by useState("")
    var statusMessage by useState<String?>(null)
   val dataProperty = getPropertyById(selectedVisit?.propertyId.toString())
//    if (dataProperties.isEmpty()){
//
//    }

    val filteredProperties = visits.filter {property->
        activeTab == "All" ||  property.visitStatus == activeTab
    }
    val visitsData by useState(it.visitSchedule)

    val handleScheduleVisit = {
        console.log("Scheduling visit:", formData)
        formData = FormData()
    }

    div {
        className = ClassName("min-h-screen bg-white flex relative")

        // Navigation
        NavBar{
            this.activeNavItem = "Visit Scheduler"
        }

        // Main Content
        div {
            className = ClassName("flex-1 p-4 lg:p-6 ml-0 lg:ml-0")
            // Page Title
            div {
                className = ClassName("text-center mb-2")
                h1 {
                    className = ClassName("text-xl lg:text-2xl font-normal text-boon-primary")
                    +"Visit Schedule"
                }
            }

            // Subtitle
            div {
                className = ClassName("text-center mb-6")
                p {
                    className = ClassName("text-sm font-normal text-black")
                    +"Manage and Track Property Visit"
                }
            }

            // Tab Navigation
            div {
                className = ClassName("flex items-start gap-5 border-b border-gray-200 mb-6")
                TabItem {
                    label = "All"
                    isActive = activeTab == "All"
                    onClick = { activeTab = "All" }
                }
                TabItem {
                    label = "Pending"
                    isActive = activeTab == "Pending"
                    onClick = { activeTab = "Pending" }
                }
                TabItem {
                    label = "Confirmed"
                    isActive = activeTab == "Confirmed"
                    onClick = { activeTab = "Confirmed" }
                }
                TabItem {
                    label = "Completed"
                    isActive = activeTab == "Completed"
                    onClick = { activeTab = "Completed" }
                }
                TabItem {
                    label = "Cancelled"
                    isActive = activeTab == "Cancelled"
                    onClick = { activeTab = "Cancelled" }
                }
            }

            // Scheduled Visits Title
            div {
                className = ClassName("text-center mb-6")
                h2 {
                    className = ClassName("text-lg lg:text-xl font-normal text-black")
                    +"Scheduled Visits"
                }
            }
            div{
                div {
                    className = ClassName("flex justify-center items-start gap-4 border-b border-gray-200 py-4 hover:bg-gray-50")

                    div {
                        className = ClassName("flex-1 justify-center flex items-center")
//                className = ClassName("flex-1 flex items-center gap-3")
//                img {
//                    src = props.avatar
//                    alt = props.name
//                    className = ClassName("w-8 h-8 rounded-full")
//                }
                        div {
                            className = ClassName("text-sm font-semibold text-black")
                            style = jso {
                                fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                            }
                            +"Customer Name"
                        }
                    }

                    div {
                        className = ClassName("flex-1 justify-center flex items-center")
                        div {
                            className = ClassName("text-sm font-semibold text-black")
                            style = jso {
                                fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                            }
                            +"Property Name"
                        }
                    }

                    div {
                        className = ClassName("flex-1 justify-center flex items-center")
                        div {
                            className = ClassName("text-sm font-semibold text-black")
                            style = jso {
                                fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                            }
                            +"Phone"
                        }
                    }

                    div {
                        className = ClassName("flex-1 justify-center flex items-center")
                        div {
                            className = ClassName("text-sm font-semibold text-black")
                            style = jso {
                                fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                            }
                            +"Email"
                        }
                    }

                    div {
                        className = ClassName("flex-1 justify-center flex items-center")
                        div {
                            className = ClassName("text-sm font-semibold text-black")
                            style = jso {
                                fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                            }
                            +"Property Type"
                        }
                    }
                    div {
                        className = ClassName("flex-1 justify-center flex items-center")
                        div {
                            className = ClassName("text-sm font-semibold text-black")
                            style = jso {
                                fontFamily = "Century Schoolbook, serif".unsafeCast<FontFamily>()
                            }
                            +"Status"
                        }
                    }
                }
                className = ClassName("w-full text-left")
            }

            // Visits Data
            div {
                className = ClassName("space-y-0 mb-8 max-h-[400px] overflow-y-auto")
                filteredProperties.forEach { visit ->
                    VisitRow {
                        name = visit.name.toString()
                        property = dataProperties.firstOrNull {dataProperty->
                            dataProperty.id == visit.propertyId
                        }?.title.toString()
                        type = visit.propertyType.toString()
                        email = visit.email.toString()
                        status = visit.visitStatus.toString()
                        phone = visit.phone.toString()
                        id = visit.propertyId.toString()
//                        avatar = visit.avatar
//                        dateTime = visit.date.toString()
                        onClick = {
                            selectedVisit = visit
                            selectedStatus = visit.visitStatus.toString()
                        }
                    }
                }
            }

            // Visit Details Slide-over
            selectedVisit?.let { visit ->



                div {
                    className = ClassName("fixed inset-y-0 right-0 z-50 w-full lg:w-1/3 bg-white shadow-lg p-6 overflow-auto")

                    div {
                        className = ClassName("flex items-start justify-between mb-4")
                        div {
                            h3 {
                                className = ClassName("text-lg font-semibold text-black")
                                +"Schedule Details"
                            }
                            div {
                                className = ClassName("text-sm text-boon-gray")
                                +"for ${visit.name} · ${visit.email}"
                            }
                        }
                        div {
                            button {
                                onClick = { selectedVisit = null }
                                className = ClassName("text-sm text-boon-gray")
                                +"Close"
                            }
                        }
                    }

                    div {
                        className = ClassName("mb-4")

                        div {
                            className = ClassName("text-sm font-normal text-black mb-2")
                            +"Property"
                        }
                        div {
                            className = ClassName("text-sm font-semibold text-black mb-2")
                            +dataProperty?.title
                        }

                        div {
                            className = ClassName("text-sm  font-normal text-black mb-2")
                            +"Type"
                        }
                        div {
                            className = ClassName("text-sm font-semibold text-black mb-2")
                            +dataProperty?.type
                        }

                        div {
                            className = ClassName("text-sm font-normal text-black mb-2")
                            +"Scheduled At"
                        }
                        div {
                            className = ClassName("text-sm font-semibold text-black mb-2")
                            +localDateFromString(visit.visitOn.toString())
                        }

                        div {
                            className = ClassName("text-sm font-normal text-black mb-2")
                            +"Current Status"
                        }
                        div {
                            className = ClassName("text-sm font-semibold text-black mb-2")
                            +visit.visitStatus
                        }
                    }

                    div {
                        className = ClassName("mb-4")
                        label {
                            className = ClassName("text-sm font-normal mb-2 block")
                            +"Change Status"
                        }
                        select {
                            value = selectedStatus
                            onChange = { e -> selectedStatus = e.target.value }
                            className = ClassName("w-full bg-[#F8F8F7] rounded-lg px-4 py-3 text-sm text-[#949494] outline-none")

                            option { value = "Pending"; +"Pending" }
                            option { value = "Confirmed"; +"Confirmed" }
                            option { value = "Completed"; +"Completed" }
                            option { value = "Cancelled"; +"Cancelled" }
                        }
                    }

                    div {
                        className = ClassName("flex items-center gap-3")
                        button {
//                            onClick = { handleUpdateStatus() }
                            className = ClassName("bg-boon-primary text-white px-4 py-2 rounded-xl text-sm font-normal")
                            +"Update Status"
                        }
                        button {
                            onClick = { selectedVisit = null }
                            className = ClassName("bg-gray-100 text-black px-4 py-2 rounded-xl text-sm font-normal")
                            +"Close"
                        }
                        statusMessage?.let { msg ->
                            div {
                                className = ClassName("text-sm font-semibold text-green-700")
                                +msg
                            }
                        }
                    }
                }
            }

            // Schedule New Visit Title
            div {
                className = ClassName("text-center mb-6")
                h3 {
                    className = ClassName("text-sm font-normal text-black")
                    +"Schedule New Visit"
                }
            }

            // Schedule New Visit Form
            div {
                className = ClassName("flex flex-col lg:flex-row gap-4 mb-6")

                // Visitor Name
                div {
                    className = ClassName("flex-1")
                    div {
                        className = ClassName("text-center mb-2")
                        label {
                            className = ClassName("text-sm font-normal text-black")
                            +"Visitor Name"
                        }
                    }
                    input {
                        type = web.html.InputType.text
                        placeholder = "Enter visitor name"
                        value = formData.visitorName
                        onChange = { e ->
                            val target = e.target.asDynamic()
                            formData = formData.copy(visitorName = target.value as String)
                        }
                        className = ClassName("w-full px-3 py-2 rounded-xl bg-boon-bg-light text-sm border-none outline-none text-boon-gray")
                        style = jso {
                            fontFamily = string("Century Schoolbook, serif")
                        }
                    }
                }

                // Property
                div {
                    className = ClassName("flex-1")
                    div {
                        className = ClassName("text-center mb-2")
                        label {
                            className = ClassName("text-sm font-normal text-black")
                            +"Property"
                        }
                    }
                    select {
                        value = formData.property
                        onChange = { e ->
                            val target = e.target.asDynamic()
                            formData = formData.copy(property = target.value as String)
                        }
                        className = ClassName("w-full px-3 py-2 rounded-xl bg-boon-bg-light text-sm border-none outline-none text-boon-gray")
                        style = jso {
                            fontFamily = string("Century Schoolbook, serif")
                        }

                        option {
                            value = ""
                            +"Select Property"
                        }
                        dataProperties.filter {
                            it.status.toString() == "Active"
                        }.forEach {
                            option {
                                value = "${it.title}, ${it.location}"
                                +"${it.title}, ${it.location}"
                            }

                        }
                    }
                }

                // Email
                div {
                    className = ClassName("flex-1")
                    div {
                        className = ClassName("text-center mb-2")
                        label {
                            className = ClassName("text-sm font-normal text-black")
                            +"Email"
                        }
                    }
                    input {
                        type = web.html.InputType.email
                        placeholder = "Enter email address"
                        value = formData.email
                        onChange = { e ->
                            val target = e.target.asDynamic()
                            formData = formData.copy(email = target.value as String)
                        }
                        className = ClassName("w-full px-3 py-2 rounded-xl bg-boon-bg-light text-sm border-none outline-none text-boon-gray")
                        style = jso {
                            fontFamily = string("Century Schoolbook, serif")
                        }
                    }
                }

                // Date & Time
                div {
                    className = ClassName("flex-1")
                    div {
                        className = ClassName("text-center mb-2")
                        label {
                            className = ClassName("text-sm font-normal text-black")
                            +"Date & time"
                        }
                    }
                    input {
                        type = web.html.InputType.datetimeLocal
                        placeholder = "Pick date & time"
                        value = formData.dateTime
                        onChange = { e ->
                            val target = e.target.asDynamic()
                            formData = formData.copy(dateTime = target.value as String)
                        }
                        className = ClassName("w-full px-3 py-2 rounded-xl bg-boon-bg-light text-sm border-none outline-none text-boon-gray")
                        style = jso {
                            fontFamily = string("Century Schoolbook, serif")
                        }
                    }
                }
            }

            // Schedule Visit Button
            div {
                className = ClassName("flex justify-start")
                button {
                    onClick = { handleScheduleVisit() }
                    className = ClassName("bg-boon-primary text-white px-4 py-3 rounded-xl text-sm font-normal")
                    style = jso {
                        fontFamily = string("Century Schoolbook, serif")
                    }
                    +"Schedule Visit"
                }
            }
        }
    }
}
